import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { Button, Card, CardContent, CardHeader, CardTitle } from '@repo-manager/ui';

export function ErrorPage() {
  const error = useRouteError();
  const heading = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : 'Something went wrong';
  const detail = error instanceof Error ? error.message : String(error);

  return (
    <div className="mx-auto max-w-2xl px-6 py-16">
      <Card>
        <CardHeader>
          <CardTitle>{heading}</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <pre className="overflow-auto rounded-md bg-muted p-4 text-xs">{detail}</pre>
          <Button asChild variant="outline">
            <Link to="/">Back to dashboard</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
